import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { IFilterComponent, SearchFilter } from 'src/app/infrastructure/iFilter-component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AdmissionService } from 'src/app/services/admission.service';
import { FilterRecordService } from 'src/app/services/filter-record.service';

@Component({
  selector: 'app-orientation-filter',
  templateUrl: './orientation-filter.component.html',
  styleUrls: ['./orientation-filter.component.css']
})
export class OrientationFilterComponent  implements IFilterComponent, OnInit {

  form: FormGroup;
  @ViewChild('formElement', {static: false}) formElement: ElementRef;

  constructor(private formBuilder: FormBuilder
    , private admissionService: AdmissionService
    , private filterRecordService: FilterRecordService) {

    this.form = this.formBuilder.group({
      Name: ['']
    });
  }

  get f() { return this.form.controls; }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  async saveFilters() {
    this.filterRecordService.saveFilters('OrientationFilterComponent', this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters('OrientationFilterComponent', this.form);
  }

  async search(): Promise<any> {
    return await this.admissionService.getOrientationSearchItem(this.form.controls.Name.value);
  }

  async ngOnInit() {

  }
}
